import { createRouter, createWebHistory } from 'vue-router'
import { defineAsyncComponent } from 'vue'
import CoachList from './pages/Coaches/CoachList.vue'
import NotFound from './pages/NotFound/NotFound.vue'
import UserAuth from './pages/Auth/UserAuth.vue'
import store from './store/index'

const CoachInfo = defineAsyncComponent(()=> import('./pages/Coaches/CoachInfo.vue'))
const CoachRegistration = defineAsyncComponent(()=> import('./pages/Coaches/CoachRegistration.vue'))
const ContactCoach = defineAsyncComponent(()=> import( './pages/Requests/ContactCoach.vue'))
const RequestList = defineAsyncComponent(()=> import('./pages/Requests/RequestList.vue'))
const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: "/", redirect: '/coaches' },
        { path: "/coaches", component: CoachList },
        {
            path: "/coaches/:id", component: CoachInfo, props: true, children: [
                { path: 'contact', component: ContactCoach }
            ]
        },
        { path: "/register", component: CoachRegistration, meta: { requiresAuth: true } },
        { path: "/requests", component: RequestList, meta: { requiresAuth: true } },
        { path: "/auth", component: UserAuth, meta: { requiresUnAuth: true } },
        { path: "/:notFound(.*)", component: NotFound },
    ],

})

router.beforeEach(function (to, from, next) {
    if (to.meta.requiresAuth && !store.getters.isAuthenthicated) {
        next('/auth')
    } else
        if (to.meta.requiresUnAuth && store.getters.isAuthenthicated) {
            next('/coaches')
        } else {
            next()
        }
})

export default router